const navConfig = [
  {
    href: '/#features',
    text: 'Our Features',
    moveToId: 'features',
  }
];

export { navConfig };
